export default __webpack_public_path__ + "static/media/cat3a.09ce3dcb.jpg";